import { useIsMobile } from "../../helpers/ui";

const PageContent = ({
  children,
  customStyles,
}: {
  children: React.ReactElement;
  customStyles?: React.CSSProperties;
}) => {
  const isMobile = useIsMobile();
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: `0px ${isMobile ? "12px" : "32px"}`,
        ...customStyles,
      }}
    >
      {children}
    </div>
  );
};

export default PageContent;
